import { Controller } from "./helpers/controller";
import {ShowLoader} from "./utils/showLoader";

export class TrialSignupSession extends Controller {

    private btnForwardStandard: JQuery = $('.btnForward');
    private btnBackStandard: JQuery = $('.btnBack');
    private btnForwardAlternate: JQuery = $('#btnForward');
    private btnBackAlternate: JQuery = $('#btnBack');
    private inCentre: JQuery = $('#inCentre');
    private chooseCentre: JQuery = $('[data-switch-choose-centre]');
    private selectedDetailsJson: JQuery = $('#selectedDetails');
    private initialChildIndex: JQuery = $('#initialChildIndex');
    private RequiredChildCount: JQuery = $('#RequiredChildCount');

    private btnEditCentre: JQuery = $('[data-switch-edit-centre]');
    private btnEditProduct: JQuery = $('[data-switch-edit-tuition]');
    private btnEditYourDetails: JQuery = $('[data-switch-edit-your-details]');
    private btnEditChildDetails: JQuery = $('[data-switch-edit-child-details]');

    private loader: JQuery = $('#loading-spinner')

    constructor(element: HTMLElement) {
        super(element);

        this.btnForwardStandard.on('click', (e) => {

            for (let i: number = 0; i < Number(this.RequiredChildCount.val()); i++) {
                $("#Children_" + i + "__DateOfBirth").val($(".DayOfBirth" + i).val() + "/" + $(".MonthOfBirth" + i).val() + "/" + $(".YearOfBirth" + i).val())
            }

            if (this.errorsOnCurrentChildrenTabOrNoTabs())
            {
                this.submitMainForm();
                return;
            }

            var firstChildTabWithErrors = this.firstChildTabWithErrors();
            if (firstChildTabWithErrors < 0) {
                this.submitMainForm();
                return;
            }

            $(".childbutton"+(firstChildTabWithErrors+1))[0].click();
            e.preventDefault();
            $('html, body').scrollTop($('.childtab1').offset().top);
        });
        this.btnBackStandard.on('click', (e) => {
            this.handleEditSelected('formBack');
        })
        this.btnForwardAlternate.on('click', (e) => {
            if (e.target.classList.contains("confirmBookingButton")) {
                if ($(e.target).hasClass("disabled")) {
                    e.preventDefault();
                    return;
                }

                $(e.target).addClass("disabled");
            }
                
            this.submitMainForm();
        });
        this.btnBackAlternate.on('click', (e) => {
            this.handleEditSelected('formBack');
        })
        this.inCentre.on('click', (e) => {
            this.chooseCentre.show();
        });
        this.btnEditCentre.on('click', (e) => {
            this.handleEditSelected('formEditTrialExperience');
        })
        this.btnEditProduct.on('click', (e) => {
            this.handleEditSelected('formEditProduct');
        })
        this.btnEditYourDetails.on('click', (e) => {
            this.handleEditSelected('formEditYourDetails');
        })
        this.btnEditChildDetails.on('click', (e) => {
            let childNumber = e.target.getAttribute('data-child-number');
            this.handleChildEditSelected('formEditChildren', Number(childNumber));
        })

        if (this.initialChildIndex.length > 0 && this.initialChildIndex.val()) {
            this.handleInitialChildDisplay(this.initialChildIndex.val());
        }
    }

    firstChildTabWithErrors = () => {
        for (var i = 0; i < 3; i++) {
            var childrenFirstNameSelector = $("#Children_"+i+"__FirstName");
            if (childrenFirstNameSelector.length != 1) {
                return -1;
            }

            if ($(childrenFirstNameSelector[0]).val() == "") {
                return i;
            }

            if ($($("#Children_"+i+"__LastName")[0]).val() == "") {
                return i;
            }

            if ($($("#Children_"+i+"__DateOfBirth")[0]).val() == "") {
                return i;
            }
        }

        return -1;
    }
    errorsOnCurrentChildrenTabOrNoTabs = () => {
        if ($(".childtab1").length == 0) {
            return true;
        }
        
        var firstChildtabWithErrors = this.firstChildTabWithErrors();

        var childrenTabSelector = $(".childtab"+(firstChildtabWithErrors+1)+".selected");
        if (childrenTabSelector.length == 1) {
            return true;
        }
        
        return false;
    }
    
    submitMainForm = () => {
        let form = <HTMLFormElement>document.getElementById('formTrialSignupMain');

        this.submitForm(form);
    }

    handleEditSelected = (formId: string) => {
        let form = <HTMLFormElement>document.getElementById(formId);
        let payload = this.selectedDetailsJson.val();
        var input = $('<input>')
            .attr('type', 'hidden')
            .attr('name', 'selectedDetailsJson')
            .val(payload);
        form.append(input.get(0));
        this.submitForm(form);
    }

    handleChildEditSelected = (formId: string, childNumber: number) => {
        let form = <HTMLFormElement>document.getElementById(formId);
        var input = $('<input>')
            .attr('type', 'hidden')
            .attr('name', 'selectedChildNumber')
            .val(childNumber);
        form.append(input.get(0));

        this.handleEditSelected(formId);
    }

    handleInitialChildDisplay = (index: number) => {
        $('li[role="tab"] a')[index].click()
    }

    submitForm = (form: HTMLFormElement) => {
        if (form !== null) {
            if ("useSpinner" in form.dataset) {
                ShowLoader(this.loader);
            }
            form.submit();
        }
    }
    

}


